import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { Auth } from 'aws-amplify';
import { switchMap } from 'rxjs/operators';
import {AdminService} from './admin.service';

/**
 * The Amplify `Auth.currentSession` method returns a promise. So we need to
 * Observablifiy it and handle the response. We are just logging a warning in this
 * interceptor if we don't have a current session.
 */
@Injectable()
export class JwtInterceptorService implements HttpInterceptor {

  constructor(private admin:AdminService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Suppress Auth header on S3 upload requests (auth in URL) and public (no-auth) calls
    if(/\.s3\./.test(request.url) || /\/public\//.test(request.url)) return next.handle(request);

    // Try to add credentials for other calls; return a request object no matter what
    const promise:Promise<HttpRequest<any>> = Auth.currentSession().then(session => {
      const jwtToken = session.getIdToken().getJwtToken();
      if (jwtToken) {
        const setHeaders:any = {
          Authorization: 'Bearer ' + jwtToken
        };
        if(this.admin.actAsPatientId) {
          if(request.method === 'GET') {
            setHeaders['X-Portal-Act-As-Patient'] = this.admin.actAsPatientId.toString();
          } else console.log("Admin acting as patient, but for "+request.method+" request; no header set");
        }
        return request.clone({setHeaders});
      } else return request;
    }).catch(error => {
      if(error !== 'No current user') {
        console.log('Error checking current sign-in for API calls');
        console.warn(error);
      }
      return request;
    });

    // With the provided request object, call the next interceptor
    return from(promise).pipe(switchMap(useRequest => next.handle(useRequest)));
  }
}
